var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyAverageMealCost = function SvgHappyAverageMealCost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDF6E9",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAA839",
    d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12m1.35 4.86h.41a.375.375 0 0 1 0 .75h-.41a1.88 1.88 0 0 1-1.84 1.5h-.095l1.86 1.86a.375.375 0 0 1-.265.64.4.4 0 0 1-.265-.11l-2.5-2.5a.38.38 0 0 1 .053-.575.37.37 0 0 1 .202-.065h1a1.125 1.125 0 0 0 1.06-.75H8.5a.375.375 0 0 1 0-.75h2.06a1.12 1.12 0 0 0-1.06-.75h-1a.375.375 0 0 1 0-.75h3.25a.375.375 0 0 1 0 .75H11c.171.22.29.477.35.75"
  })));
};
export default SvgHappyAverageMealCost;